import React from 'react';
import styles from './index.module.less';
import type { IStudentInfo } from '@/types';

interface IProps {
    dataSource: IStudentInfo;
}

const defaultHeadImgUrl = '//simg01.gaodunwangxiao.com/v/Uploads/avatar/default.jpg';

const StudentInfo = (props: IProps) => {
    const { dataSource } = props;

    return (
        <div className={styles['student-info-wrap']}>
            <div className={styles['student-info-meta']}>
                <div className={styles['student-info-meta-avatar']}>
                    <img
                        src={dataSource.headImgUrl || defaultHeadImgUrl}
                        onError={event => {
                            event.currentTarget.src = defaultHeadImgUrl;
                        }}
                    />
                </div>
                <div className={styles['student-info-meta-name']}>{dataSource.nickName}</div>
            </div>
            <div className={styles['student-info-statistic-wrap']}>
                <div className={styles['student-info-statistic']}>
                    <div className={styles['student-info-statistic-title']}>加入高顿</div>
                    <div className={styles['student-info-statistic-content']}>
                        <strong>{dataSource.days}</strong>天
                    </div>
                </div>
                <div className={styles['student-info-statistic-line']}></div>
                <div className={styles['student-info-statistic']}>
                    <div className={styles['student-info-statistic-title']}>累计做题</div>
                    <div className={styles['student-info-statistic-content']}>
                        <strong>{dataSource.itemDone}</strong>道
                    </div>
                </div>
            </div>
        </div>
    );
};

export default StudentInfo;
